/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import LoadingOverlay from "../../../utilities/LoadingOverlay";
import { ClipLoader } from "react-spinners";
import { defaultLoadingOverlayStyles } from "../../../utilities/loadingOverlay.styles";
import { selectAlertMessage } from "../../../state/ducks/alert/index";
import Modal from "../Modal/index";
import {
  clearNewMemberRedirect,
  saveNewMembers,
  addNewMembers,
  selectMemberInfo,
} from "../../../state/ducks/member";
import {
  selectAuthenticate,
} from "../../../state/ducks/login/index";
import Countdown from "react-countdown";
import $ from "jquery";
import StaticModal from "../shared/StaticModal";
import ReactPixel from "react-facebook-pixel";
import NumberFormat from "react-number-format";

function changebg() {
  var num = Math.ceil(Math.random() * 2);
  document.body.background = "assets/img/loginBackground/loginback_" + num + ".jpg";
  document.body.style.backgroundSize = "cover";
}

class NewMemberSave extends Component {
  state = {
    kod: "",
    loginType: 1,
    platform: "web",
    token: "",
  };

  componentDidMount() {
    this.props.clearRedirect();
    changebg();
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
  }

  componentDidUpdate() {
    if (this.props.member?.saveMember) {
      this.props.clearRedirect();
      this.props.history.push("/yeniuyelikbasarili");
    }
  }

  beginAuthenticate = () => {
    const { member } = this.props;
    const postData = {
      username: member.newMember.telefonNo,
      password: this.state.kod,
      loginType: this.state.loginType,
      platform: this.state.platform,
      token: this.state.token,
      authType: 2,
    };
    this.props.beginAuthenticate(postData);
    this.setState({
      userName: "",
      password: "",
    });

    this.createCaptchaToken();
  };

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  timerEnd() {
    $("#kod").prop("disabled", true);
    $("#submit").css("pointer-events", "none");
    $("#tekrar_gonder").css("pointer-events", "all");
  }

  timerStart() {
    var time = this.props.member?.countDate + 180000 < Date.now();
    $("#kod").prop("disabled", time);
    $("#submit").css("pointer-events", "all");
    if (time) {

      $("#tekrar_gonder").css("pointer-events", "all");
     
      
    } else {
      $("#tekrar_gonder").css("pointer-events", "none");
      $("#submit").css("pointer-events", "all");
    }
    if (this.props.member?.saveMember) {
      $("#tekrar_gonder").css("pointer-events", "none");
    }
  }

  resetCounter() {
    const { member } = this.props;

    const postData = {
      ad: member.newMember.ad,
      soyad: member.newMember.soyad,
      token: this.state.token,
      reklamIzni: member.newMember.reklamIzni,
      sehirId: member.newMember.sehirId,
      ilceId: member.newMember.ilceId,
      telefonNo: member.newMember.telefonNo,
    };
    this.props.addNewMember(postData);
    this.createCaptchaToken();
  }

  saveNewMember = (event) => {
    event.preventDefault();

    var mesaj = document.getElementById("mesaj");

    var control = true;
    mesaj.innerHTML = "";

    //sms kodu alanı
    if (this.state.kod === "") {
      mesaj.innerHTML = "Sms Kodu alanını boş bırakılamaz.";
      $("#hata_mesaji").modal("show");
      control = false;
    } else {
      $("#hata_mesaji").modal("hide");

    }
    if (control) {
      const { member } = this.props;

      const postData = {
        kimlikNo: member.newMember.kimlikNo,
        telefonNo: member.newMember.telefonNo,
        ad: member.newMember.ad,
        soyad: member.newMember.soyad,
        dogumTarihi: member.newMember.dogumTarihi,
        sehirId: member.newMember.sehirId,
        ilceId: member.newMember.ilceId,
        kod: this.state.kod,
        reklamIzni: member.newMember.reklamIzni,
      };

      this.props.saveNewMember(postData);
      this.createCaptchaToken();
    }
  };

  render() {
    const { alert, member } = this.props;
    return (
      <LoadingOverlay
        active={alert?.loading}
        spinner={<ClipLoader />}
        styles={defaultLoadingOverlayStyles}
      >
        <div className="container-fluid">
          <Modal message={alert?.message} type={alert?.type} />
          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div
              className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlaniPopup"
            >
              <div className="row no-gutters d-flex justify-content-center px-4">
                {/* LOGO */}
                <div className="col-12 d-flex justify-content-center pb-2">
                  <i className="t-icon-lock_clock t-loginSifreAlBaslikIcon" />
                </div>
                <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                  SMS DOĞRULAMA
                </div>
                <div
                  className="col-12 col-lg-8 pb-2 text-center"
                  style={{ color: "#95C11F" }}
                >
                  <strong>
                    {member?.newMember?.telefonNo?.substring(1, 3) +
                      "********" +
                      member?.newMember?.telefonNo?.substring(12, 14)}
                  </strong>{" "}
                  nolu cep telefonunuza gönderilen kodu giriniz.
                </div>
                {/* TC Kimlik */}
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <span className="t-loginText pl-3">SMS Şifreniz</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-phonelink_lock" />
                    </div>
                    <NumberFormat
                      displayType={"input"}
                      maxLength="6"
                      minLength="6"
                      id="kod"
                      name="kod"
                      className="smsdecimalnumber"
                      placeholder="SMS Doğrulama Kodunu Giriniz"
                      value={this.state.kod}
                      onChange={(e) => {
                        this.setState({ kod: e.target.value });
                      }}
                      required={true}
                      autoComplete="new-password"
                    />
                    <div />
                  </div>
                </div>
                <div
                  className="col-12 col-lg-8 py-4 text-center"
                  style={{ color: "#F39200", fontWeight: "bold" }}
                >
                  <i className="t-icon-clock" />
                  <Countdown
                    key={this.props.member?.countDate}
                    date={this.props.member?.countDate + 180000}
                    renderer={(props) => (
                      <strong id="count_down">
                        {" "}
                        {props.total / 1000} sn
                      </strong>
                    )}
                    onStart={() => this.timerStart()}
                    onComplete={() => this.timerEnd()}
                  ></Countdown>
                </div>
                {/* Geri Sayım JS si*/}
                {/* Geri Sayım JS si BİTTİ*/}
                {/* ara boşluk*/}
                <div className="col-12" />
                {/* GİRİŞ ve GERİ DON */}
                <div className="col-auto pt-4 px-1">
                  <a
                    href="#tekrar"
                    target="_parent"
                    id="tekrar_gonder"
                    onClick={() => this.resetCounter()}
                    className="t-loginGeridonButton"
                  >
                    <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                    TEKRAR GÖNDER
                    <span className="pr-2" />
                  </a>
                </div>
                <div className="col-auto pt-4 px-1">
                  <button
                    className="t-loginGirisButton"
                    id="submit"
                    name="submit"
                    type="submit"
                    onClick={this.saveNewMember}>
                    <span className="px-2" />
                    ONAYLA
                    <i
                      className="t-icon-arrow-right2 pl-2"
                      style={{ fontSize: "14pt" }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <StaticModal></StaticModal>
        </div>
      </LoadingOverlay>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    alert: selectAlertMessage(state),
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearRedirect: () => dispatch(clearNewMemberRedirect()),
  addNewMember: (newMember) => dispatch(addNewMembers(newMember)),
  saveNewMember: (newMember) => dispatch(saveNewMembers(newMember)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMemberSave);
